module.exports = __webpack_public_path__ + "img/invoice.55528749.png";